var _line, _path, _ellipse, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 202,
    viewBox: "0 0 132 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67.2721,
    y1: 68.3848,
    x2: 67.2721,
    y2: -0.000770555,
    stroke: "url(#paint0_linear_3804_22324)",
    strokeWidth: 0.636145
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9523 74.7462C73.9523 73.0591 73.282 71.441 72.089 70.248C70.896 69.055 69.278 68.3848 67.5908 68.3848C65.9037 68.3848 64.2856 69.055 63.0926 70.248C61.8996 71.441 61.2294 73.0591 61.2294 74.7462L67.5908 74.7462H73.9523Z",
    fill: "url(#paint1_linear_3804_22324)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0361,
    cy: 4.77108,
    rx: 27.0361,
    ry: 4.77108,
    transform: "matrix(-1 0 0 1 94.6259 95.4219)",
    fill: "url(#paint2_linear_3804_22324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.5542 99.832H94.6265L132 201.882H0L40.5542 99.832Z",
    fill: "url(#paint3_linear_3804_22324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6258 100.192C94.6258 93.022 91.7773 86.1452 86.7071 81.075C81.6368 76.0047 74.76 73.1563 67.5896 73.1563C60.4192 73.1562 53.5424 76.0047 48.4722 81.075C43.4019 86.1452 40.5535 93.022 40.5535 100.192L67.5896 100.192H94.6258Z",
    fill: "url(#paint4_linear_3804_22324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3804_22324",
    x1: 67.5902,
    y1: 34.192,
    x2: 68.5902,
    y2: 34.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402C5E",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8865BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3804_22324",
    x1: 62.1273,
    y1: 71.3988,
    x2: 73.8722,
    y2: 71.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3804_22324",
    x1: 3.81627,
    y1: 2.26053,
    x2: 53.5413,
    y2: -0.870306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3804_22324",
    x1: 66,
    y1: 99.832,
    x2: 66,
    y2: 201.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246075,
    stopColor: "#38117D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2268",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3804_22324",
    x1: 44.3697,
    y1: 85.9659,
    x2: 94.2857,
    y2: 85.4113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/Lamp.4a7f36d298c010e40646f7d0d0b68273.svg";
export { ForwardRef as ReactComponent };